export default __webpack_public_path__ + "static/media/brand-gradient.947cb318.png";